import { render, staticRenderFns } from "./KeyBenefits.vue?vue&type=template&id=3c7a089a&scoped=true"
import script from "./KeyBenefits.vue?vue&type=script&lang=js"
export * from "./KeyBenefits.vue?vue&type=script&lang=js"
import style0 from "./KeyBenefits.vue?vue&type=style&index=0&id=3c7a089a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a089a",
  null
  
)

export default component.exports